import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';

function AuthorizedRouter({ user, path, component: Component }) {
  if (
    user?.account?.xbot?.support ||
    (user?.unit?.staffs ?? []).indexOf(user.email) !== -1 ||
    Object.values(user?.unit?.groups ?? {}).some(({ staffs }) => staffs.includes(user.email))
  ) {
    return <Route exact path={path} render={(props) => <Component {...props} />} />;
  }
  return (
    <Route
      exact
      path={path}
      render={(props) => <Redirect to={{ pathname: '/', state: { from: props.location } }} />}
    />
  );
}

const mapStateToProps = ({ user }) => ({
  user,
});

export default withRouter(connect(mapStateToProps)(AuthorizedRouter));
